/* eslint-disable no-constant-condition */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable prefer-spread */
/* eslint-disable prefer-const */
/* eslint-disable no-var */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable no-empty */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/await-thenable */

/* eslint-disable no-async-promise-executor */

import React from "react";
import Select, { StylesConfig } from "react-select";
import "./styles.css";
import AppText from "components/AppText";

const themedSelectStyles: StylesConfig = {
  control: (base, state) => ({
    ...base,
    backgroundColor: "var(--input-bg)",
    borderColor: state.isFocused
      ? "var(--border-focus)"
      : "var(--input-border)",
    boxShadow: state.isFocused ? "0 0 0 1px var(--border-focus)" : "none",
    color: "var(--text-primary)",
    minHeight: 42,
    "&:hover": {
      borderColor: state.isFocused
        ? "var(--border-focus)"
        : "var(--border-strong)",
    },
  }),
  menu: (base) => ({
    ...base,
    backgroundColor: "var(--bg-surface-elevated)",
    border: "1px solid var(--border-default)",
    boxShadow: "var(--shadow-md)",
    zIndex: 30,
    overflow: "hidden",
  }),
  menuList: (base) => ({
    ...base,
    backgroundColor: "var(--bg-surface-elevated)",
    paddingTop: 4,
    paddingBottom: 4,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? "var(--bg-info-subtle)"
      : state.isFocused
        ? "var(--bg-hover)"
        : "transparent",
    color: "var(--text-primary)",
    cursor: "pointer",
    ":active": {
      backgroundColor: "var(--bg-hover)",
    },
  }),
  singleValue: (base) => ({
    ...base,
    color: "var(--text-primary)",
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "var(--bg-muted)",
  }),
  multiValueLabel: (base) => ({
    ...base,
    color: "var(--text-primary)",
  }),
  multiValueRemove: (base) => ({
    ...base,
    color: "var(--text-muted)",
    ":hover": {
      backgroundColor: "var(--bg-hover)",
      color: "var(--text-primary)",
    },
  }),
  placeholder: (base) => ({
    ...base,
    color: "var(--input-placeholder)",
  }),
  input: (base) => ({
    ...base,
    color: "var(--text-primary)",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    backgroundColor: "var(--border-default)",
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: "var(--text-muted)",
    ":hover": {
      color: "var(--text-secondary)",
    },
  }),
  clearIndicator: (base) => ({
    ...base,
    color: "var(--text-muted)",
    ":hover": {
      color: "var(--text-secondary)",
    },
  }),
};

const SelectDropdown = (props: any) => {
  const {
    containerClassName,
    data,
    isDisabled,
    isLoading,
    name,
    getOptionValue,
    getOptionLabel,
    isClearable,
    onChange,
    defaultValue,
    formatOptionLabel,
    label,
    isMulti,
    closeMenuOnSelect,
    style,
    showClearAll,
    onPressClearAll,
    labelClassname,
    styles: stylesProp,
    ...rest
  } = props;
  return (
    <div
      className={`${containerClassName || ""} select-dropdown-container`}
      style={style}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        {label && (
          <p className={`select-dropdown-label ${labelClassname || ""}`}>
            <AppText>{label}</AppText>
          </p>
        )}

        {showClearAll && (
          <p
            className="googledisplay-targeting-section-clear-all-text"
            onClick={onPressClearAll}
          >
            <AppText>clear all</AppText>
          </p>
        )}
      </div>
      <Select
        isMulti={isMulti}
        formatOptionLabel={formatOptionLabel}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
        className="basic-single"
        classNamePrefix="select"
        defaultValue={defaultValue}
        isDisabled={isDisabled}
        isLoading={isLoading}
        isClearable={isClearable}
        name={name}
        options={data}
        onChange={onChange}
        closeMenuOnSelect={closeMenuOnSelect}
        styles={{ ...themedSelectStyles, ...stylesProp }}
        {...rest}
      />
    </div>
  );
};

export default SelectDropdown;
